module.exports = __webpack_public_path__ + "img/woman-torso-back.87862ac3.png";